import { useState } from "react";
import { Button, Checkbox, Modal, Typography } from "antd";
import { ROUTES } from "Features/Routes/routeConstants";

const { Title, Paragraph, Text, Link } = Typography;

export const TermsPoliciesModal = ({
  open,
  onAccept,
  onCancel,
  loading,
  policyVersion,
  effectiveDate,
  documentUrl,
}) => {
  const [checked, setChecked] = useState(false);
  const href = documentUrl || ROUTES.TERMS;

  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      maskClosable={false}
      width={640}
    >
      <Title level={3}>OneGrad Terms &amp; Policies</Title>
      <Paragraph>
        Before you continue, please review and accept the OneGrad Terms &amp;
        Policies (which includes our Terms of Service, Privacy Policy, Refund
        Policy, and Scholarship Terms).
      </Paragraph>
      <Paragraph>
        <Text strong>Effective Date:</Text> {effectiveDate || "11/18/2024"}
        <br />
        <Text strong>Version:</Text> {policyVersion || "1.1"}
      </Paragraph>
      <Paragraph>
        You can read the full document here:{" "}
        <Link href={href} target="_blank" rel="noreferrer">
          Terms &amp; Policies
        </Link>{" "}
        (opens in a new tab).
      </Paragraph>
      <Paragraph>
        <Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)}>
          I have read and agree to the OneGrad Terms &amp; Policies, including the
          Privacy Policy, Refund Policy, and Scholarship Terms.
        </Checkbox>
      </Paragraph>
      <Paragraph type="secondary">
        Your acceptance will be recorded (date/time, version, and device info)
        for compliance purposes.
      </Paragraph>
      <div className="flex justify-end gap-3">
        <Button onClick={onCancel}>Cancel</Button>
        <Button
          type="primary"
          disabled={!checked}
          loading={loading}
          onClick={onAccept}
        >
          Agree &amp; Continue
        </Button>
      </div>
    </Modal>
  );
};
